@switch (columnName) {
  @default {
    {{ element[columnName] ?? '---' }}
  }
  @case ('jobType') {
    @if (isCorrectiveActionPerform) {
      {{ 'correctiveAction' | translate }}
    } @else if (element.jobType) {
      {{ element.jobType }}
    } @else {
      {{ 'maintenanceJob' | translate }}
    }
  }
  @case ('expiryType') {
    @if (element.expiryType === 'IntervalExpiry' || element.expiryType === 'Both') {
      <mat-icon matTooltip="{{ 'intervalExpiry' | translate }}">schedule</mat-icon>
    }
    @if (element.expiryType === 'RuntimeExpiry' || element.expiryType === 'Both') {
      <mat-icon matTooltip="{{ 'runtimeExpiry' | translate }}">event_repeat</mat-icon>
    }
    @if (isOneTimeExpiryType) {
      <mat-icon matTooltip="{{ 'oneTimeExpiry' | translate }}">looks_one</mat-icon>
    }
    @if (isOneTimeExpiryAndRuntime) {
      <mat-icon matTooltip="{{ 'runtimeExpiry' | translate }}">event_repeat</mat-icon>
    }
    @if (!element.expiryType) {
      ---
    }
  }
  @case ('responsible') {
    @for (position of element.responsibleForPositions ?? []; track position?.id ?? position) {
      <div>
        {{ position?.name }}
      </div>
    }
    @for (
      positionGroup of element.responsibleForPositionGroups ?? [];
      track positionGroup?.id ?? positionGroup
    ) {
      <div>
        {{ positionGroup?.name }}
      </div>
    }
    @for (role of element.responsibleForRoles ?? []; track role?.id ?? role) {
      <div>
        {{ role?.name }}
      </div>
    }
  }
  @case ('locationTooltip') {
    <app-text-overflow-label [text]="element?.menu?.path"></app-text-overflow-label>
  }
  @case ('location') {
    {{ element?.menu?.path }}
  }
  @case ('critical') {
    @if (element.isCriticalComponent) {
      <mat-icon matTooltip="{{ 'jobBelongsToCriticalComponent' | translate }}">warning</mat-icon>
    }
  }
  @case ('edit') {
    <app-ui-button
      buttonType="icon-button"
      icon="edit"
      [ariaLabel]="'edit' | translate"
      (click)="buttonFunctions.edit()"
    ></app-ui-button>
  }
  @case ('delete') {
    <app-ui-button
      buttonType="icon-button"
      icon="delete"
      [ariaLabel]="'delete' | translate"
      (click)="buttonFunctions.delete()"
    ></app-ui-button>
  }
  @case ('quantity') {
    {{ element?.quantity }} {{ element?.quantityType?.name }}
  }
  @case ('usedQuantity') {
    {{ element?.usedQuantity }} {{ element?.quantityType?.name }}
  }
  @case ('quantityType') {
    {{ element?.quantityType?.name }}
  }
  @case ('dueDateRuntime') {
    @if (isOneTimeExpiryType) {
      @if (oneTimeOrIntervalDueDate) {
        {{ oneTimeOrIntervalDueDate | date }}
      } @else {
        ---
      }
      @if (isOneTimeExpiryAndRuntime && runtimeDueHours !== null && runtimeDueHours !== undefined) {
        | {{ runtimeDueHours }} h
      }
    } @else {
      @if (intervalDueDate) {
        {{ intervalDueDate | date }}
      } @else {
        ---
      }
      @if (runtimeDueHours !== null && runtimeDueHours !== undefined) {
        | {{ runtimeDueHours }} h
      }
    }
  }
  @case ('interval') {
    @if (element.expiryType === 'IntervalExpiry' || element.expiryType === 'Both') {
      @if (intervalDays !== null && intervalDays !== undefined) {
        {{ intervalDays }}d
      } @else {
        ---
      }
    }
    @if (element.expiryType === 'Both') {
      /
    }
    @if (element.expiryType === 'RuntimeExpiry' || element.expiryType === 'Both') {
      @if (runtimeHours !== null && runtimeHours !== undefined) {
        {{ runtimeHours }}h
      } @else {
        ---
      }
    }
    @if (!element.expiryType || isOneTimeExpiryType) {
      ---
    }
  }
  @case ('timeUntilExpiry') {
    @if (element.expiryType === 'IntervalExpiry' || element.expiryType === 'Both') {
      @if (intervalTimeUntilExpiry !== null && intervalTimeUntilExpiry !== undefined) {
        {{ intervalTimeUntilExpiry | number: '1.0-0' }}d
      } @else {
        ---
      }
    }
    @if (isOneTimeExpiryType) {
      @if (intervalTimeUntilExpiry !== null && intervalTimeUntilExpiry !== undefined) {
        {{ intervalTimeUntilExpiry | number: '1.0-0' }}d
      } @else {
        ---
      }
    }
    @if (isCombinedExpiryType) {
      or
    }
    @if (hasRuntimeExpiryDisplay) {
      @if (
        runtimeTimeUntilExpiry !== null &&
        runtimeTimeUntilExpiry !== undefined &&
        runtimeAvgDailyRuntime !== null &&
        runtimeAvgDailyRuntime !== undefined
      ) {
        {{ runtimeTimeUntilExpiry }}h at {{ runtimeAvgDailyRuntime }}h/d
      } @else {
        ---
      }
    }
    @if (!element.expiryType) {
      ---
    }
  }
  @case ('status') {
    <div class="maintenance-job-status-cell">
      <app-ui-pill
        [name]="(element.isPaused ? element.pauseStatusSnapshot : element[columnName]) ?? ''"
      ></app-ui-pill>
      @if (element.isPaused) {
        <app-department-paused-badge></app-department-paused-badge>
      }
    </div>
  }
  @case ('pausable') {
    <div class="pausable-cell">
      {{ (element.pausable ? 'yes' : 'no') | translate }}
    </div>
  }
  @case ('actions') {
    @if (showPerformButton) {
      @if (isCorrectiveActionPerform) {
        <app-ui-button
          buttonType="secondary"
          text="{{ (element.isDraft ? 'openDraft' : 'perform') | translate }}"
          [routerLink]="performRoute"
          [queryParams]="performRouteQueryParams"
          privilege="CORRECTIVE-ACTION_PERFORM"
          [disabled]="performButtonDisabled"
          [tooltip]="performButtonTooltip | translate"
        ></app-ui-button>
      } @else {
        <app-ui-button
          buttonType="secondary"
          text="{{ (element.isDraft ? 'openDraft' : 'perform') | translate }}"
          [routerLink]="performRoute"
          [queryParams]="performRouteQueryParams"
          privilege="MAINTENANCE-JOB_PERFORM"
          [disabled]="performButtonDisabled"
          [tooltip]="performButtonTooltip | translate"
        ></app-ui-button>
      }
    }
  }
  @case ('access') {
    <app-positions-cell [element]="element"></app-positions-cell>
  }
  @case ('project') {
    <app-text-overflow-label [text]="element.project?.name ?? '---'"></app-text-overflow-label>
  }
  @case ('restore') {
    <app-ui-button
      appConfirmDialog
      confirmTitle="restore"
      confirmMessage="youAreRestoring"
      [confirmEntityName]="element.name"
      (confirmed)="restore()"
      buttonType="secondary"
      text="{{ 'restore' | translate }}"
      appStopClickPropagation
      [privilege]="Privileges.MaintenanceJobRestore"
    ></app-ui-button>
  }
  @case ('reactivate') {
    <app-ui-button
      appConfirmDialog
      appStopClickPropagation
      confirmTitle="reactivate"
      confirmButtonText="reactivate"
      [confirmEntityName]="element['name']"
      confirmMessage="youAreReactivating"
      [showAreYouSure]="true"
      (confirmed)="reactivate()"
      text="{{ 'reactivate' | translate }}"
      buttonType="secondary"
      privilege="MAINTENANCE-JOB_ENABLE"
    ></app-ui-button>
  }
}
